"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterIcon = exports.StyledSettingsSelector = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const settings_selector_1 = require("../../enrich-ai-settings-widget/settings-selector");
const icons_1 = require("../../../icons");
exports.StyledSettingsSelector = (0, styled_components_1.default)(settings_selector_1.SettingsSelector) `
  ul {
    background-color: ${ui_components_1.baseColors.white};
  }
`;
exports.StyledFilterIcon = (0, styled_components_1.default)(icons_1.FilterIcon) `
  font-size: 0.8rem;
  vertical-align: baseline;

  path {
    fill: ${ui_components_1.baseColors.primaryBlueMed400};
  }
`;
